module.exports = __webpack_public_path__ + "img/NS-M-6.83d491b6.svg";